import React from 'react';
import { Helmet } from 'react-helmet';
import { XCircle, Home, ShoppingBag } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function PaymentFailure({ className = '' }: { className?: string }) {
  return (
    <div className={`min-h-screen ${className}`} style={{background: 'var(--raisin-black-2)', color: 'var(--white)'}}>
      <Header />
      <div className="h-20" />
      <Helmet><title>Payment Failed - Oracle Gaming</title><meta name="description" content="Your payment failed" /></Helmet>
      <section className="gears" style={{paddingTop: '120px', paddingBottom: '100px'}}>
        <div className="container">
          <h2 className="h2 section-title" style={{color:'var(--white)', marginBottom: '40px', textAlign: 'center'}}>PAYMENT FAILED</h2>
          <div style={{background: 'var(--raisin-black-1)', padding: '60px 40px', textAlign: 'center', borderRadius: '4px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}>
            <div style={{background: '#dc2626', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 30px'}}>
              <XCircle style={{width: '40px', height: '40px', color: 'var(--white)'}} />
            </div>
            <h1 style={{fontSize: '36px', fontWeight: 'bold', color: 'var(--white)', marginBottom: '20px', fontFamily: 'var(--ff-oswald)', textTransform: 'uppercase'}}>Payment Failed</h1>
            <p style={{fontSize: '18px', color: 'var(--light-gray)', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px', lineHeight: '1.6'}}>Unfortunately we couldn't process your transaction. Please try again or choose a different payment method.</p>
            <div style={{display: 'flex', flexDirection: 'row', gap: '20px', justifyContent: 'center', flexWrap: 'wrap'}}>
              <Link to="/" className="btn btn-primary" style={{display: 'inline-flex'}}>
                <Home style={{width: '20px', height: '20px'}} />
                Back to Home
              </Link>
              <Link to="/shop" className="btn" style={{border: '1px solid rgba(20, 254, 251, 0.4)', color: 'var(--white)'}}>
                <ShoppingBag style={{width: '20px', height: '20px'}} />
                Try Again
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

